export const DESCRIPTION_BLOCK_CONTENT_MAP: Record<string, Record<string, string>> = {
  design: {
    title: 'ПРОСТОТА И ГАРМОНИЯ',
    name: 'Дизайнерский',
    text: 'Лаконичный дизайнерский стиль совмещает в\u00A0себе ультрасовременные тенденции, удобство форм ' +
      'и\u00A0практичность материалов. Минималистичное сочетание мебели и\u00A0техники сохраняет максимум ' +
      'пространства для приготовления кулинарных шедевров и\u00A0общения с\u00A0близкими людьми.',
  },
  sharm: {
    title: 'ЭЛЕГАНТНОСТЬ И ИЗЯЩЕСТВО',
    name: 'Шарм',
    text: 'Даже небольшой кухне можно придать настроение французского Прованса. Нежные пастельные тона, ' +
      'натуральные материалы, лёгкость и\u00A0утонченность деталей позволят создать интерьер, наполненный ' +
      'солнечным светом, спокойствием и\u00A0уютом.',
  },
  nature: {
    title: 'ЕСТЕСТВЕННАЯ КРАСОТА И УЮТ',
    name: 'Природный',
    text: 'Для кухни в\u00A0природном стиле характерны аутентичность и\u00A0легкость. Природные цвета ' +
      'и\u00A0древесные текстуры подчеркнут стиль, навеянный самой природой.',
  },
  neo: {
    title: 'ИЗЫСКАННОСТЬ И ПРОСТОТА',
    name: 'Неоклассика',
    text: 'Неоклассика\u00A0\u2014 это симметрия, строгость и\u00A0чистота линий, синтез традиций ' +
      'и\u00A0современности. Опираясь на\u00A0элементы античной архитектуры, неоклассика приветствует ' +
      'современные материалы и\u00A0технологии.',
  },
};
